import { render } from "./index.vue?vue&type=template&id=1a5b3a5a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "@/style/chapter-list.less?vue&type=style&index=0&id=1a5b3a5a&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5b3a5a"],['__file',"src/views/bookmark/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a5b3a5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a5b3a5a', __exports__)) {
    console.log('reload')
    api.reload('1a5b3a5a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1a5b3a5a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1a5b3a5a', render)
  })

}


export default __exports__